import React, { useState } from "react";
import Sidebar from "./ui/Sidebar";
import { Menu } from "lucide-react";

const AppLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden bg-brand-50">
      {/* Sidebar fijo desktop */}
      <div className="hidden lg:flex lg:flex-shrink-0">
        <div className="w-64 flex flex-col">
          <Sidebar onClose={() => setSidebarOpen(false)} />
        </div>
      </div>

      {/* Overlay sidebar móvil */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/50 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar móvil (drawer) */}
      <div
        className={`fixed inset-y-0 left-0 z-50 w-64 flex flex-col transform transition-transform duration-300 ease-in-out lg:hidden ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <Sidebar mobileOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      </div>

      {/* Contenido principal */}
      <div className="flex flex-col flex-1 overflow-hidden">
        {/* Topbar móvil */}
        <header className="lg:hidden flex items-center justify-between bg-white border-b border-brand-100 px-4 py-3 shadow-sm">
          <button
            onClick={() => setSidebarOpen(true)}
            className="p-2 rounded-lg text-brand-600 hover:bg-brand-50 transition-colors"
          >
            <Menu className="h-5 w-5" />
          </button>
          <div className="flex items-center gap-2">
            <img
              src="/vetronix_navbar.png"
              alt="Vetronix"
              className="h-8 w-auto object-contain"
            />
          </div>
          <div className="w-9" /> {/* spacer */}
        </header>

        {/* Área de scroll del contenido */}
        <main className="flex-1 overflow-y-auto">
          <div className="animate-fadeIn">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default AppLayout;
